// The chat that slides in over a desktop page (TOM-738): wider than 768 px,
// every boat page but the chat itself takes Neo's full chat, the Chats page's
// thread and composer with Behind the answer beside it, sliding in from the
// right over whatever is on screen. The sparkle that opens it stays on screen
// as a right arrow that slides it back out. At 768 px and under, the web keeps
// home's chat and the sparkle's (TOM-511, TOM-547).
//
// Pure, so cloud/web's Node vitest covers it (no DOM harness).

/** The routes under a boat with the slide-in chat on a desktop. */
export function isSlideChatRoute(pathname: string, boatTo: string): boolean {
  const path = pathname.replace(/\/+$/, '');
  // The chat is the page there already.
  if (path === `${boatTo}/neo` || path.startsWith(`${boatTo}/neo/`)) return false;
  // The toolkit carries its own chat beside its tools (MarineToolkit.tsx).
  if (path === `${boatTo}/toolkit` || path.startsWith(`${boatTo}/toolkit/`)) return false;
  return path === boatTo || path.startsWith(`${boatTo}/`);
}

/**
 * The AI Watch page under a boat, which has its own Neo thread (ADR 0196). A
 * board whose address holds "/watch", such as `/boards/watch-keeping`, is not
 * it: there the board's chats answer as on any board (TOM-1049).
 */
export function isWatchRoute(pathname: string, boatTo: string): boolean {
  const path = pathname.replace(/\/+$/, '');
  return path === `${boatTo}/watch` || path.startsWith(`${boatTo}/watch/`);
}

/** What the sparkle says, closed or open, with the dot or without. */
export function slideChatButtonLabel(open: boolean, unread: boolean): string {
  if (open) return 'Close chat';
  return unread ? 'Open Neo. Neo has a new message.' : 'Open Neo';
}

/**
 * Whether an Escape that reached the window closes the slide-in chat: not one
 * a dialog, a menu or the composer's own menu already took (it was handled),
 * and not while one of those is open.
 */
export function slideChatEscapeCloses(input: {
  key: string;
  defaultPrevented: boolean;
  /** The Escape came from inside a dialog or a menu, or one is open. */
  insideOther: boolean;
}): boolean {
  return input.key === 'Escape' && !input.defaultPrevented && !input.insideOther;
}
